import * as THREE from 'three';

// Loads the city lake tools/build-fountain.mjs prepared - the photo and
// its lossless masks (R sky, G lake, B balustrade) - once, at startup, for
// visualizers/fountain.js. Same preload/get shape as fairground-assets.js,
// and the same rule: the preload is a WIRING POINT every entry point must
// call (main, main-radio, main-embedded, play-boot, player-boot,
// landing-boot, demo-boot, the capture harness). Resolves to null when the
// photo or the masks are missing: the entry points then withdraw Fountain
// (disableVisualization) - without its picture it is unavailable.
const MANIFEST_URL = 'textures/fountain.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}

export function preloadFountain() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('fountain.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      if (!manifest.webp || !manifest.png || !manifest.horizon || !manifest.nozzles) throw new Error('fountain.json incomplete (run tools/build-fountain.mjs)');
      return Promise.all([
        loadTexture('textures/' + manifest.webp, function (t) {
          t.colorSpace = THREE.SRGBColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.LinearFilter;
          t.magFilter = THREE.LinearFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        // the masks are data: no colour space; linear filtering keeps the
        // build's softened edge
        loadTexture('textures/' + manifest.png, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.LinearFilter;
          t.magFilter = THREE.LinearFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, photo: parts[0], mask: parts[1] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] fountain assets unavailable, Fountain will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getFountain() {
  return _assets;
}
